<label
  class="fdz-dropzone"
  [class.fdz-dragover]="dragOver()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <input
    type="file"
    class="fdz-input"
    [multiple]="multiple()"
    [accept]="accept()"
    (change)="onInputChange($event)"
  />
  <mat-icon aria-hidden="true">upload_file</mat-icon>
  <span>{{ hint() }}</span>
</label>
